import types from './types'

const fetchingReport = program => {
  return {
    type: types.FETCHING_REPORT,
    program,
  }
}

const fetchingReportSuccess = (program, reportData) => {
  return {
    type: types.FETCHING_REPORT_SUCCESS,
    program,
    reportData,
  }
}

const fetchingReportError = (
  error = 'There was a problem loading your report. Please try again later.',
  program,
) => {
  return {
    type: types.FETCHING_REPORT_ERROR,
    error,
    program,
  }
}

const deleteReportsSuccess = () => {
  return {
    type: types.DELETE_REPORTS_SUCCESS,
  }
}

export default {
  fetchingReport,
  fetchingReportSuccess,
  fetchingReportError,
  deleteReportsSuccess,
}



// WEBPACK FOOTER //
// ./src/redux/reports/actions.js